export enum FormActionType {
    HIDE = 'HIDE',
    READ_ONLY = 'READ_ONLY',
    EDITABLE = 'EDITABLE',
    REQUIRE = 'REQUIRE',
}
